import {
  createListAllQuery,
  listStickyNotes,
  ListStickyNotesQueryVariables,
  StickyNote as StickyNoteGraphql,
} from '@akin-home/amplify';

export const listAllStickyNotesQuery = createListAllQuery<
  StickyNoteGraphql,
  ListStickyNotesQueryVariables
>(listStickyNotes, 'listStickyNotes');
